import React, { Component } from 'react';
import RUTransportsEntry from './RUTransportsEntry';
import RUTransportsByLotContent from './UsedRentalsByLot/RUTransportsByLotContent';
import RUTransportsWRTContent from './UsedRentalsWaitingRequest/RUTransportsWRTContent';
import RUTransportsWADContent from './UsedRentalsWaitingArrival/RUTransportsWADContent';
import RUTransportsAtDContent from './UsedRentalsAtDestination/RUTransportsAtDContent';


export class RUTransportsContent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      content: this.props.showContent
    };
  }

  handleChangeContent = (newContent) => {
    this.setState({
      content: newContent
    });
  };


  render() {
    return (
      <div>
        {this.state.content === 'transportsUsedRentals' ?
          <RUTransportsEntry handleChangeContent={this.handleChangeContent.bind(this)} />
          : this.state.content === 'ruTransportsByLot' ?
            <RUTransportsByLotContent handleChangeContent={this.handleChangeContent.bind(this)} showContent={this.state.content} />
            : this.state.content === 'ruTransportsWaitingRequest' ?
              <RUTransportsWRTContent handleChangeContent={this.handleChangeContent.bind(this)} showContent={this.state.content} />
              : this.state.content === 'ruTransportsWaitingArrival' ?
                <RUTransportsWADContent handleChangeContent={this.handleChangeContent.bind(this)} showContent={this.state.content} />
                : this.state.content === 'ruTransportsAtDestination' ?
                  <RUTransportsAtDContent handleChangeContent={this.handleChangeContent.bind(this)} showContent={this.state.content} />
                  : null}
      </div>
    )
  }
}

export default RUTransportsContent;


// WEBPACK FOOTER //
// ./src/components/UsedRentals/UsedRentalsTransport/RUTransportsContent.js